// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpanSectionOne{
    font-size: 36px;
    font-style: italic;
    font-weight: 900;
    line-height: 43.2px;
    text-align: right;
}
@media (max-width: 1280px) {
    .eyeimg{
        width: 380px;
        margin-top: 50px;
     }
     .SpanSectionOne{
        font-size: 20px;
        font-weight: 900;
        line-height: 40px;
    }
}

@media (max-width: 500px) {
    .eyeimg{
        margin: 50px;
        width: 95%;
     }

    .SpanSectionOne{
        font-style: normal;
        font-size: 20px;
        font-weight: 900;
        line-height: 25px;
    }
}

/* secton Two */
.sectionTwoTable{
    width: 80%;
    margin: auto;
    border-collapse: collapse;
    color :"white";
}

.TableHeadingTitle{
    font-size: 18px;
    line-height: 25px;
    border-radius: 10px 0px 0px 0px;
    border: 1px 0px 0px 0px;
    background: rgba(6, 41, 97);
    border: rgba(6, 41, 97);
    position: sticky;
    top:0;
}

.TableHeadingTitle th{
    font-weight: 500;
    line-height: 25px;
    padding: 15px 0px 15px 50px;
    text-align: left;
}
.TableHeadingTitle th:nth-child(1){
    width: 30%;
}
.TableHeadingTitle th:nth-child(2){
    width: 15%;
}

.TableHeadingTitle th:nth-child(3){
    width: 30%;
}

.TabledataHeading{
    background: rgba(21, 108, 254, 0.13);
    text-align: left;
    font-size: 16px;
    font-weight: 900;
    line-height: 22.4px;
    text-align: left;
}

.TabledataHeading th{
    padding: 10px 0px 5px 40px;
    border: rgba(3, 24, 57);
}

.Tabledata td{
    padding: 10px 0px 10px 40px;
    font-size: 14px;
    line-height: 19.6px;
}
tbody tr{
    border: 5px solid rgba(0, 11, 28, 1);
}

@media (max-width: 1280px) {
    .FeatureCircle {
        display: flex;
        flex-direction: row;
    }
    .FeatureCircle img{
        width: 20px;
        height: 20px;
    }
}

@media (max-width: 500px) {
    .sectionTwoTable{
        width: 100%;
    }
    .TableHeadingTitle{
        font-size: 10px;
    }
    .TableHeadingTitle th{
        font-weight: 500;
        line-height: 15px;
        padding: 5px 5px 5px 5px;
        text-align: left;
    }
    .TabledataHeading{
        text-align: left;
        font-size: 12px;
        font-weight: 900;
        line-height: 10px;
    }
    .TabledataHeading th{
        padding: 5px 5px 5px 5px;
    }
    
    .Tabledata td{
        flex-direction: column;
        padding: 5px 5px 5px 5px;
        font-size: 12px;
        line-height: 19.6px;
    }
    tbody tr{
        border: 2px solid rgba(0, 11, 28, 1);
    }
    
    .FeatureCircle {
        display: flex;
    }
    .FeatureCircle img{
        width: 20px;
    }
}

/* 3 */
.FeaturesSectionThree {
    width: 100%;
    height: 550px;
}
#Featurebigscreen{
    display: block;
}
#Featuresmallscreen{
    display: none;
}

@media (max-width: 500px) {
    #Featurebigscreen{
        display: none;
    }
    #Featuresmallscreen{
        display: block;
    }
}

/* 4 */
.FeaturesSectionFour{
    width: 100%;
}

@media (max-width: 500px) {
    .FeaturesSectionFour{
        height: auto;
        margin-top: -50px;
    }
}`, "",{"version":3,"sources":["webpack://./src/ApiGateway/Styles/Features.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI;QACI,YAAY;QACZ,gBAAgB;KACnB;KACA;QACG,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,UAAU;KACb;;IAED;QACI,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;;AAEA,eAAe;AACf;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;IAChB,KAAK;AACT;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,wBAAwB;QACxB,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,wBAAwB;QACxB,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,oCAAoC;IACxC;;IAEA;QACI,aAAa;IACjB;IACA;QACI,WAAW;IACf;AACJ;;AAEA,MAAM;AACN;IACI,WAAW;IACX,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;AACJ;;AAEA,MAAM;AACN;IACI,WAAW;AACf;;AAEA;IACI;QACI,YAAY;QACZ,iBAAiB;IACrB;AACJ","sourcesContent":[".SpanSectionOne{\r\n    font-size: 36px;\r\n    font-style: italic;\r\n    font-weight: 900;\r\n    line-height: 43.2px;\r\n    text-align: right;\r\n}\r\n@media (max-width: 1280px) {\r\n    .eyeimg{\r\n        width: 380px;\r\n        margin-top: 50px;\r\n     }\r\n     .SpanSectionOne{\r\n        font-size: 20px;\r\n        font-weight: 900;\r\n        line-height: 40px;\r\n    }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    .eyeimg{\r\n        margin: 50px;\r\n        width: 95%;\r\n     }\r\n\r\n    .SpanSectionOne{\r\n        font-style: normal;\r\n        font-size: 20px;\r\n        font-weight: 900;\r\n        line-height: 25px;\r\n    }\r\n}\r\n\r\n/* secton Two */\r\n.sectionTwoTable{\r\n    width: 80%;\r\n    margin: auto;\r\n    border-collapse: collapse;\r\n    color :\"white\";\r\n}\r\n\r\n.TableHeadingTitle{\r\n    font-size: 18px;\r\n    line-height: 25px;\r\n    border-radius: 10px 0px 0px 0px;\r\n    border: 1px 0px 0px 0px;\r\n    background: rgba(6, 41, 97);\r\n    border: rgba(6, 41, 97);\r\n    position: sticky;\r\n    top:0;\r\n}\r\n\r\n.TableHeadingTitle th{\r\n    font-weight: 500;\r\n    line-height: 25px;\r\n    padding: 15px 0px 15px 50px;\r\n    text-align: left;\r\n}\r\n.TableHeadingTitle th:nth-child(1){\r\n    width: 30%;\r\n}\r\n.TableHeadingTitle th:nth-child(2){\r\n    width: 15%;\r\n}\r\n\r\n.TableHeadingTitle th:nth-child(3){\r\n    width: 30%;\r\n}\r\n\r\n.TabledataHeading{\r\n    background: rgba(21, 108, 254, 0.13);\r\n    text-align: left;\r\n    font-size: 16px;\r\n    font-weight: 900;\r\n    line-height: 22.4px;\r\n    text-align: left;\r\n}\r\n\r\n.TabledataHeading th{\r\n    padding: 10px 0px 5px 40px;\r\n    border: rgba(3, 24, 57);\r\n}\r\n\r\n.Tabledata td{\r\n    padding: 10px 0px 10px 40px;\r\n    font-size: 14px;\r\n    line-height: 19.6px;\r\n}\r\ntbody tr{\r\n    border: 5px solid rgba(0, 11, 28, 1);\r\n}\r\n\r\n@media (max-width: 1280px) {\r\n    .FeatureCircle {\r\n        display: flex;\r\n        flex-direction: row;\r\n    }\r\n    .FeatureCircle img{\r\n        width: 20px;\r\n        height: 20px;\r\n    }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    .sectionTwoTable{\r\n        width: 100%;\r\n    }\r\n    .TableHeadingTitle{\r\n        font-size: 10px;\r\n    }\r\n    .TableHeadingTitle th{\r\n        font-weight: 500;\r\n        line-height: 15px;\r\n        padding: 5px 5px 5px 5px;\r\n        text-align: left;\r\n    }\r\n    .TabledataHeading{\r\n        text-align: left;\r\n        font-size: 12px;\r\n        font-weight: 900;\r\n        line-height: 10px;\r\n    }\r\n    .TabledataHeading th{\r\n        padding: 5px 5px 5px 5px;\r\n    }\r\n    \r\n    .Tabledata td{\r\n        flex-direction: column;\r\n        padding: 5px 5px 5px 5px;\r\n        font-size: 12px;\r\n        line-height: 19.6px;\r\n    }\r\n    tbody tr{\r\n        border: 2px solid rgba(0, 11, 28, 1);\r\n    }\r\n    \r\n    .FeatureCircle {\r\n        display: flex;\r\n    }\r\n    .FeatureCircle img{\r\n        width: 20px;\r\n    }\r\n}\r\n\r\n/* 3 */\r\n.FeaturesSectionThree {\r\n    width: 100%;\r\n    height: 550px;\r\n}\r\n#Featurebigscreen{\r\n    display: block;\r\n}\r\n#Featuresmallscreen{\r\n    display: none;\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    #Featurebigscreen{\r\n        display: none;\r\n    }\r\n    #Featuresmallscreen{\r\n        display: block;\r\n    }\r\n}\r\n\r\n/* 4 */\r\n.FeaturesSectionFour{\r\n    width: 100%;\r\n}\r\n\r\n@media (max-width: 500px) {\r\n    .FeaturesSectionFour{\r\n        height: auto;\r\n        margin-top: -50px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
